// extracted by mini-css-extract-plugin
module.exports = {"leftSide":"styles_leftSide__3i0t6","leftSideWithOutChat":"styles_leftSideWithOutChat__16BjA","feedContainer":"styles_feedContainer__8A-RG","rightSide":"styles_rightSide__3qQHp"};